import { render, staticRenderFns } from "./ButtonSelector.vue?vue&type=template&id=2f140430&"
import script from "./ButtonSelector.vue?vue&type=script&lang=js&"
export * from "./ButtonSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports